import { render, staticRenderFns } from "./outputBasicData2.vue?vue&type=template&id=a951323e&scoped=true&"
import script from "./outputBasicData2.vue?vue&type=script&lang=js&"
export * from "./outputBasicData2.vue?vue&type=script&lang=js&"
import style0 from "./outputBasicData2.vue?vue&type=style&index=0&id=a951323e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a951323e",
  null
  
)

export default component.exports